var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectListEmptyDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75.3633,
    r: 75,
    fill: "#47484A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3337 92.03H91.667V100.363H58.3337V92.03ZM58.3337 75.3633H91.667V83.6967H58.3337V75.3633ZM83.3337 33.6967H50.0003C45.417 33.6967 41.667 37.4467 41.667 42.03V108.697C41.667 113.28 45.3753 117.03 49.9587 117.03H100C104.584 117.03 108.334 113.28 108.334 108.697V58.6967L83.3337 33.6967ZM100 108.697H50.0003V42.03H79.167V62.8633H100V108.697Z",
    fill: "#4FA736"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListEmptyDark);
export default __webpack_public_path__ + "static/media/project-list-empty-dark.07f1920e552801c91c362f0d2373b324.svg";
export { ForwardRef as ReactComponent };